import U from './../lib-utils'
import abstractLayer from './abstractLayer'
import events from './lib-events'
import libUnit from './../lib-units'
import Mustache from './../../mustache/mustache'
import resultTemplate from '!!raw-loader!./templates/ruller/result.html'
require('./style/ruller-layer.scss')

var gUNITS = {
  mm: 'мм',
  cm: 'см',
  sm: 'см',
  m: 'м',
  km: 'км',
}

function rullerLayer() {
  return (rullerLayer.is(this) ? this.init : rullerLayer.F).apply(
    this,
    Array.prototype.slice.call(arguments),
  )
}

var P = rullerLayer.leu_extend(abstractLayer).prototype

P.canvas = null
P.context = null
P.canvas_antialiasing_supported = null
P.svg_filters_supported = null
P.rullerStartX = null //image pcu X of ruller start point
P.rullerStartY = null //image pcu Y of ruller start point
P.rullerEndX = null //image pcu X of ruller end point
P.rullerEndY = null //image pcu Y of ruller end point
P.enabled = true
P.active = false
//
P.rullerResult = null
P.rullerUnit = null
P.rullerXPCU = null
P.rullerYPCU = null

P.on_init = function () {
  this.handle = document.createElement('div')
  this.handle.classList.add('lib-map-layer')
  this.handle.classList.add('lib-map-layer-ruller-v-cnv')
  this.canvas = document.createElement('canvas')
  this.handle.appendChild(this.canvas)
  this.context = this.canvas.getContext('2d')
  this.canvas_antialiasing_supported = U.is_defined(
    this.context.imageSmoothingQuality,
  )
  this.svg_filters_supported = U.is_defined(this.context.filter)

  try {
    this.context.imageSmoothingEnabled = true
    this.context.imageSmoothingQuality = 'high'
  } catch (e) {
    //do nothing
  }
  this.enabled = true
  this.layout.centralData.lem.on(
    events._RULLER_PRESET_CHANGED,
    this,
    this.onGridPreferencesChanged,
  )
  //
  this.layout.centralData.lem.on(
    events._RULLER_STATUS,
    this,
    this.runRullerStatus,
  )
  this.layout.centralData.lem.on(events._RULLER_CLEAR, this, this.clearRuller)
  this.layout.centralData.lem.on(
    events._RULLER_ACTIVATE,
    this,
    this.startRuller,
  )
  return this
}

P.startRuller = function () {
  this.clearRuller()
  this.active = true
  this.layout.centralData.lem.run(events._RULLER_STATUS_CHANGED)
}

P.runRullerStatus = function (e, r) {
  r.status = this.active
}

P.onGridPreferencesChanged = function () {
  var cdr = U.safeObject(
    U.safeObject(
      U.safeObject(U.safeObject(this.layout.centralData).project).custom_data,
    ).ruller,
  )
  this.rullerWidth = U.IntMoreOr(cdr.rullerWidth, 0, 2)
  this.rullerColor = U.NEString(cdr.rullerColor, '#fff0f0ff')

  var ruUnitId = U.NEString(cdr.unit, 'mm')
  var gsuDomain = libUnit().domain('linear')
  if (gsuDomain) {
    this.rullerUnit = gsuDomain.get(ruUnitId)
  } else {
    this.rullerUnit = null
  }
  this.rullerXPCU = null
  this.rullerYPCU = null
  if (null !== this.rullerUnit) {
    var pcuValx = U.floatMoreOr(cdr.xPcuVal, 0, null) // размер эталона в pcu
    var pcuValy = U.floatMoreOr(cdr.yPcuVal, 0, null) //
    if (null !== pcuValx && null !== pcuValy) {
      var kx = U.floatMoreOr(cdr.xK, 0, null) // количесво юнитов в эталоне
      var ky = U.floatMoreOr(cdr.yK, 0, null) // количесво юнитов в эталоне (y)
      if (null !== kx && null !== ky) {
        if (gsuDomain) {
          var xUnit = gsuDomain.get(U.NEString(cdr.xUnit, '&&'))
          var yUnit = gsuDomain.get(U.NEString(cdr.yUnit, '&&'))
          if (null !== xUnit && null !== yUnit) {
            var kxWithUnit = gsuDomain.convert(xUnit, this.rullerUnit, kx) // количество юнитов линейки  на pcuValx pcu
            var kyWithUnit = gsuDomain.convert(yUnit, this.rullerUnit, ky) // количество юнитов линейки  на pcuValy pcu
            // приводим к весу 1 pcu в выбранных юнитах
            var xPcuPerRullerUnit = pcuValx / kxWithUnit // количесво pcu в юнитах линейки
            var yPcuPerRullerUnit = pcuValy / kyWithUnit
            this.rullerXPCU = U.floatMoreOr(xPcuPerRullerUnit, 0, null)
            this.rullerYPCU = U.floatMoreOr(yPcuPerRullerUnit, 0, null)
          }
        }
      }
    }
  }
  this.calculateRuller()
  this.draw()
}

P.clearRuller = function () {
  this.rullerEndX = null
  this.rullerEndY = null
  this.rullerStartX = null
  this.rullerStartY = null
  this.calculateRuller()
  this.draw()
  this.layout.centralData.lem.run(events._RULLER_STATUS_CHANGED)
}

P.calculateRuller = function () {
  this.rullerResult = null
  console.log('calc ruller')
  if (this.rullerXPCU === null) this.rullerXPCU = 1
  if (this.rullerYPCU === null) this.rullerYPCU = 1
  if (this.rullerUnit === null)
    this.rullerUnit = {
      domain: 'linear',
      id: 'mm',
      name: 'millimeter',
      si: false,
      ks: 0.001,
    }
  // if (this.rullerXPCU === null) this.rullerXPCU = 1
  console.log(
    this.rullerStartX,
    this.rullerStartY,
    this.rullerEndX,
    this.rullerEndY,
    this.rullerXPCU,
    this.rullerYPCU,
    this.rullerUnit,
  )
  if (
    null !== this.rullerStartX &&
    null !== this.rullerStartY &&
    null !== this.rullerEndX &&
    null !== this.rullerEndY &&
    null !== this.rullerXPCU &&
    null !== this.rullerYPCU &&
    null !== this.rullerUnit
  ) {
    var dxpcu = this.rullerEndX - this.rullerStartX
    var dypcu = this.rullerEndY - this.rullerStartY
    var dxunit = dxpcu / this.rullerXPCU
    var dyunit = dypcu / this.rullerYPCU
    var lenpcu = Math.sqrt(dxpcu * dxpcu + dypcu * dypcu)
    var lenunit = Math.sqrt(dxunit * dxunit + dyunit * dyunit)
    var sq = Math.abs(dxunit) * Math.abs(dyunit)
    this.rullerResult = {
      pcu: {
        dx: dxpcu,
        dy: dypcu,
        len: lenpcu,
        s: dxpcu * dypcu,
      },
      unit: {
        dx: dxunit,
        dy: dyunit,
        len: lenunit,
        s: sq,
      },
      unitLabel: U.NEString(gUNITS[this.rullerUnit.id], this.rullerUnit.id),
      printable: {
        pcu: {
          dx: dxpcu.toFixed(3),
          dy: dypcu.toFixed(3),
          len: lenpcu.toFixed(3),
          s: (dxpcu * dypcu).toFixed(3),
        },
        unit: {
          dx: dxunit.toFixed(3),
          dy: dyunit.toFixed(3),
          len: lenunit.toFixed(3),
          s: sq.toFixed(3),
        },
      },
    }
    console.log('ruller Layer')
    this.layout.centralData.set_ui_state(
      'APP-HEADER-TEXT',
      Mustache.render(resultTemplate, this.rullerResult),
    )
  } else {
    this.layout.centralData.set_ui_state('APP-HEADER-TEXT', '')
  }
}

/**
 * Вызывается менеджером
 * @returns {rullerLayer}
 */
P.clear = function () {
  this.context.clearRect(
    0,
    0,
    this.get_layout_width(),
    this.get_layout_height(),
  )
  return this
}

/**
 * Вызывается менеджером после ресайза
 * @returns {rullerLayer}
 */
P.resize = function () {
  this.canvas.width = this.get_layout_width()
  this.canvas.height = this.get_layout_height()
  return this
}

/**
 *
 * @returns {rullerLayer}
 */
P.on_data_ready = function () {}

P.on_image_ready = function () {
  this.onGridPreferencesChanged()
}

P.on_click_tap = function (evt) {
  if (this.active) {
    evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false)
    evt.stopPropagation()
    //console.log(evt);
    if (null === this.rullerStartX && null === this.rullerStartY) {
      this.rullerStartX = evt.calculated.image.pcu.x
      this.rullerStartY = evt.calculated.image.pcu.y
      this.draw()
    } else {
      console.log('second pont')
      if (evt.ctrlKey || evt.metaKey) {
        this.rullerEndX = evt.calculated.image.pcu.x
        this.rullerEndY = this.rullerStartY
      } else if (evt.altKey) {
        this.rullerEndY = evt.calculated.image.pcu.y
        this.rullerEndX = this.rullerStartX
      } else {
        this.rullerEndX = evt.calculated.image.pcu.x
        this.rullerEndY = evt.calculated.image.pcu.y
      }
      this.active = false
      this.layout.centralData.lem.run(events._RULLER_STATUS_CHANGED)
      this.draw()
    }
    this.calculateRuller()
    return true
  }
}

P.on_hover = function (event) {
  if (this.active && null !== this.rullerStartX && null !== this.rullerStartY) {
    if (event.ctrlKey || event.metaKey) {
      this.rullerEndX = event.calculated.image.pcu.x
      this.rullerEndY = this.rullerStartY
    } else if (event.altKey) {
      this.rullerEndY = event.calculated.image.pcu.y
      this.rullerEndX = this.rullerStartX
    } else {
      this.rullerEndX = event.calculated.image.pcu.x
      this.rullerEndY = event.calculated.image.pcu.y
    }
    this.draw()
    this.calculateRuller()
  }
}

/**
 * Вызывается менеджером, внутри animationFrame. Менеджер сам проверит корректность входных данных
 * @returns {rullerLayer}
 */
P.draw = function () {
  this.context.clearRect(
    0,
    0,
    this.get_layout_width(),
    this.get_layout_height(),
  )
  if (!this.enabled) {
    return
  }
  if (
    null !== this.rullerStartX &&
    null !== this.rullerStartY &&
    null !== this.rullerEndX &&
    null !== this.rullerEndY
  ) {
    try {
      this.context.imageSmoothingEnabled = true
      this.context.msimageSmoothingEnabled = true
      this.context.mozimageSmoothingEnabled = true
      this.context.webkitimageSmoothingEnabled = true
      this.context.imageSmoothingQuality = 'high'
    } catch (e) {
      //do nothing
    }
    //coordinates are image pcu
    var start = this.layout.calculator.translate_image_pcu(
      this.rullerStartX,
      this.rullerStartY,
      this.layout.layout_width,
      this.layout.layout_height,
      this.layout.scale,
      this.layout.center_x,
      this.layout.center_y,
    )
    var end = this.layout.calculator.translate_image_pcu(
      this.rullerEndX,
      this.rullerEndY,
      this.layout.layout_width,
      this.layout.layout_height,
      this.layout.scale,
      this.layout.center_x,
      this.layout.center_y,
    )
    var rd = Math.atan2(
      end.viewport.px.y - start.viewport.px.y,
      end.viewport.px.x - start.viewport.px.x,
    )
    var deg = (rd * 180) / Math.PI
    var deg2 = deg - 90
    var rd2 = (deg2 * Math.PI) / 180
    var lpx1 = start.viewport.px.x + Math.cos(rd2) * 5
    var lpx2 = start.viewport.px.x + Math.cos(rd2) * -5
    var lpx3 = end.viewport.px.x + Math.cos(rd2) * 5
    var lpx4 = end.viewport.px.x + Math.cos(rd2) * -5
    var lpy1 = start.viewport.px.y + Math.sin(rd2) * 5
    var lpy2 = start.viewport.px.y + Math.sin(rd2) * -5
    var lpy3 = end.viewport.px.y + Math.sin(rd2) * 5
    var lpy4 = end.viewport.px.y + Math.sin(rd2) * -5
    //var k = Math.tan(rd2);
    //var b1 = -1 * (k * start.viewport.px.x - start.viewport.px.y);
    //var b2 = -1 * (k * end.viewport.px.x - end.viewport.px.y);
    //console.log('y1=',k,'*x1+',b1,'rd2:',rd2,',deg2:',deg2);
    //console.log('y2=',k,'*x2+',b2);
    this.context.beginPath()
    this.context.moveTo(start.viewport.px.x, start.viewport.px.y)
    this.context.lineTo(end.viewport.px.x, end.viewport.px.y)
    this.context.strokeStyle = this.rullerColor
    this.context.lineWidth = 2 //this.rullerWidth * Math.min(1, this.layout.scale);
    this.context.stroke()
    this.context.beginPath()
    this.context.strokeStyle = this.rullerColor
    this.context.lineWidth = 2 //this.rullerWidth * Math.min(1, this.layout.scale);

    this.context.moveTo(lpx1, lpy1)
    this.context.lineTo(lpx2, lpy2)
    this.context.moveTo(lpx3, lpy3)
    this.context.lineTo(lpx4, lpy4)
    //var x11 = start.viewport.px.x - 10 * this.layout.scale;
    //var y11 = k * x11 + b1;
    //var x12 = start.viewport.px.x + 10 * this.layout.scale;
    //var y12 = k * x12 + b1;
    //this.context.moveTo(x11, y11);
    //this.context.lineTo(x12, y12);
    //
    //var x21 = end.viewport.px.x - 10 * this.layout.scale;
    //var y21 = k * x21 + b2;
    //var x22 = end.viewport.px.x + 10 * this.layout.scale;
    //var y22 = k * x22 + b2;
    //this.context.moveTo(x21, y21);
    //this.context.lineTo(x22, y22);
    this.context.stroke()
  }
}

P.enableLayer = function () {
  this.enabled = true
  this.draw()
}

P.disableLayer = function () {
  this.enabled = false
  this.draw()
}

export default rullerLayer
